import { useFormContext } from "react-hook-form";
import type { UseMutationOptions } from "react-query";
import { useMutation } from "react-query";
import { useWorkflowsApi } from "@/react/api";
import type { Params } from "@/react/helpers/urlHelpers";
import { minimumDelay } from "@circle-react/helpers/dateTimeHelpers";

export const useActivateWorkflow = (
  options: UseMutationOptions<undefined, Error, void> = {},
  params: Params = {},
) => {
  const { watch } = useFormContext();
  const id = watch("id") as string;
  const workflowsApi = useWorkflowsApi();

  return useMutation(
    () => minimumDelay(workflowsApi.activate({ id, params }), 500),
    {
      onError: error => {
        console.error(error);
      },
      ...options,
    },
  );
};
